var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-menu-item-2"},[_c('LocalisedLink',{staticClass:"sub-menu-item-2__link",attrs:{"to":_vm.item.link}},[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.item.external)?_c('tws-new-window-icon'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }